module.exports = __webpack_public_path__ + "static/media/coachs-hero.14fb02f5.jpg";